// Constants
import { protocols } from "../../../../config/constants";
// Components
import ProtocolPrescription from "../protocolPrescription";
// Assets
import TowersImg from "../../../../assets/protocol_towers.png";
import BalloonsImg from "../../../../assets/protocol_balloons.png";
import RunnerImg from "../../../../assets/protocol_runner.png";

export const RenderProtocols = (protocolId, t, protocolPrescriptions, isDisabledInputs, prescriptionsToDatabase, patientId, software) => {
  switch (Number(protocolId)) {
    case protocols.clinicAndHome.TOWERS.id:
      return (
        <ProtocolPrescription
          key={protocolId}
          protocolImg={TowersImg}
          protocolName={t("protocols.towers")}
          prescriptions={protocolPrescriptions}
          protocolId={protocolId}
          isDisabledInputs={isDisabledInputs}
          prescriptionsToDatabase={prescriptionsToDatabase}
          patientId={patientId}
          software={software}
        />
      );
    case protocols.clinicAndHome.BALLOONS.id:
      return (
        <ProtocolPrescription
          key={protocolId}
          protocolImg={BalloonsImg}
          protocolName={t("protocols.balloons")}
          prescriptions={protocolPrescriptions}
          protocolId={protocolId}
          isDisabledInputs={isDisabledInputs}
          prescriptionsToDatabase={prescriptionsToDatabase}
          patientId={patientId}
          software={software}
        />
      );
    case protocols.clinicAndHome.RUNNER.id:
      return (
        <ProtocolPrescription
          key={protocolId}
          protocolImg={RunnerImg}
          protocolName={t("protocols.runner")}
          prescriptions={protocolPrescriptions}
          protocolId={protocolId}
          isDisabledInputs={isDisabledInputs}
          prescriptionsToDatabase={prescriptionsToDatabase}
          patientId={patientId}
          software={software}
        />
      );
    default:
      break;
  }
};
